import api from "../api";

export async function addRestaurantType(formData: FormData) {
  const res = await api.post("/restaurant-types", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data.type ?? res.data;
}

export async function deleteRestaurantType(id: number | string) {
  const res = await api.delete(`/restaurant-types/${id}`);
  return res.data;
}

export async function fetchRestaurantTypes() {
  const res = await api.get("/restaurant-types");
  return res.data.types ?? res.data;
}

export async function hideRestaurantType(id: number | string) {
  const res = await api.post(`/restaurant-types/${id}/hide`);
  return res.data;
}

export async function unhideRestaurantType(id: number | string) {
  const res = await api.post(`/restaurant-types/${id}/unhide`);
  return res.data;
}

export async function updateRestaurantType(
  id: number | string,
  formData: FormData,
) {
  const res = await api.post(`/restaurant-types/${id}`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data.type ?? res.data;
}
